import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const Wrapper = styled.div`
  ${({ theme }) => css`
    /* background-image: url('img/fundo-login.png');
    background-size: cover;
    background-repeat: no-repeat; */
    background-color: ${theme.colors.white};
    width: 100%;
    min-height: calc(100vh - 96px);
  `}
`

export const Container = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;
    max-width: ${theme.grid.container};
    margin-left: auto;
    margin-right: auto;
    padding-left: calc(${theme.grid.gutter} / 2);
    padding-right: calc(${theme.grid.gutter} / 2);
  `}
`

export const BoxContent = styled.div`
  height: calc(100vh - 96px);
  width: 100%;
`

export const BoxTitle = styled.div`
  width: 100%;
  max-width: 600px;
  min-height: calc(100vh - 96px);
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin: 0;
  padding-left: 25px;
  ${media.lessThan('small')`
    min-height: auto;
    justify-content: start;
    display: flex;
    flex-direction: row;
    padding-left: 5px;
  `}

  ${media.greaterThan('huge')`
    max-width: 700px;
    padding-left: 45px;
  `}
`
export const BoxLogin = styled.div`
  width: 100%;
  min-height: calc(100vh - 96px);
  background: #f8eff8;
  border-radius: 20px;
  ${media.lessThan('small')`
    border-radius: 0px;
    min-height: calc(100vh - 300px);
  `}
`
export const Box = styled.div`
  width: 100%;
  min-height: 100%;
  max-width: 400px;
`

export const Title = styled.h1`
  ${({ theme }) => css`
    color: ${theme.colors.black};
    font-size: 46px;
    font-weight: 500;
    line-height: 1.2;
    margin-bottom: 45px;

    span {
      color: ${theme.colors.secondary};
      &.primary {
        color: ${theme.colors.primary};
      }
    }
    ${media.lessThan('small')`
      font-size: 24px;
      margin-bottom: 10px;
    `}
  `};
`

export const BoxCart = styled.div``

export const BoxTinta = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  align-items: end;
  ${media.lessThan('small')`
    width:80%;
  `}
`

export const BoxImage = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  opacity: 0;
  animation: fadeInLeft 1s ease-out forwards;
  animation-delay: 3.5s;
  img {
    width: 100%;
  }
  @keyframes fadeInLeft {
    from {
      opacity: 0;
      transform: translateX(-50px); /* Mova a div 50px para a esquerda */
    }
    to {
      opacity: 1;
      transform: translateX(
        0px
      ); /* Mova a div de volta para a posição original */
    }
  }
  ${media.lessThan('small')`
    position:sticky;
    opacity: 1;
    animation: none;
  `}
`
